class ExpandableContent {
  CLASSES = {
    visible: 'visible',
  };

  constructor($container) {
    if (!($container.length)) {
      return;
    }

    this.nodes = {
      $container,
      $trigger: $container.find('.js-expandable-trigger'),
      $content: $container.find('.js-expandable-content'),
    };

    this.nodes.$trigger.on('click', () => {
      this.nodes.$content.toggleClass(this.CLASSES.visible);
    });
  }
}

export default ExpandableContent;
